export const validateCount = value => {
    return value === 0 ? 0 : value || '-';
}

export const validateCountToNum = value => {
    return isNaN(value) ? 0 : value;
}